export var PLAN_CATALOG_LIMIT = 1000;
export var PLAN_DEFAULT_PAGE = 1;
export var PLAN_ALERT_AUTO_CLOSE = 10000;
export var PLAN_REFRESH_DELAY_MS = 3000;
export var PREMIUM_EVAL_OPTION_ID = "953abee0-fa8f-4341-91c0-af822a658918";
export var CATALOG_TYPE_PAYMENT_MODE = "CATALOG_PAYMENT_MODE";
export var BENEFIT_DELETE_ENTITY = "BenefitEntity";
export var TAB_BENEFITS = 0;
export var TAB_PRIMES = 1;
export var ACTION_EDIT = "edit";
export var ACTION_DELETE = "delete";
export var DEFAULT_PRIME_AGE_RANGE = [18, 65];
export var LOADING_TEXT = "Cargando...";
export var TOAST_PLAN_CREATED = "Plan creado correctamente";
export var TOAST_PLAN_UPDATED = "Plan actualizado correctamente";
export var TOAST_BENEFIT_CREATED = "Beneficio creado correctamente";
export var TOAST_BENEFIT_UPDATED = "Beneficio actualizado correctamente";
export var TOAST_RECORD_DELETED = "Registro eliminado correctamente";
export var DELETE_TITLE_BENEFIT = "beneficio";
export var DELETE_TITLE_PRIME = "prima";
export var PAGE_TITLE = "Planes";
export var BACK_LABEL = "Regresar";
export var BENEFIT_FORM_TITLE = "Información del beneficio";
export var PRIME_FORM_TITLE = "Información de la prima";
export var FORMS_PLANS_TEXTS = {
    labelButtonAddPlan: "Agregar planes",
    labelButtonAdd: "Guardar plan",
    labelButtonAddBenefits: "Agregar beneficios",
    labelButtonAddPrimes: "Agregar primas",
    titleButtonAdd: "Agregar",
    titleButtonCancel: "Cancelar",
    benefitsTitle: "Beneficios",
    primesTitle: "Tabla de primas",
    textLegend: "Para crear un beneficio, primero es necesario crear un plan.",
};
export var MODAL_DELETE_TITLE = "Eliminar";
export var modalDeleteQuestion = function (title) {
    return "\u00BFEst\u00E1 seguro que desea eliminar ".concat(title, "?");
};
export var MODAL_DELETE_CANCEL_LABEL = "No";
export var MODAL_DELETE_CONFIRM_LABEL = "Si, eliminar";
export var routeProductPlans = function (productId) {
    return "/product-creation/".concat(productId, "/true/true");
};
